module.exports = __webpack_public_path__ + "img/3.b7844b2a.jpg";